/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CtmsCategoryRespVo
 */
export interface CtmsCategoryRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof CtmsCategoryRespVo
     */
    id?: number;
    /**
     * 分类名称
     * @type {string}
     * @memberof CtmsCategoryRespVo
     */
    categoryName?: string;
    /**
     * 分类名称（英文）
     * @type {string}
     * @memberof CtmsCategoryRespVo
     */
    categoryNameEn?: string;
    /**
     * 分类名称(中文)
     * @type {string}
     * @memberof CtmsCategoryRespVo
     */
    categoryNameCn?: string;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof CtmsCategoryRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof CtmsCategoryRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof CtmsCategoryRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the CtmsCategoryRespVo interface.
 */
export function instanceOfCtmsCategoryRespVo(value: object): value is CtmsCategoryRespVo {
    return true;
}

export function CtmsCategoryRespVoFromJSON(json: any): CtmsCategoryRespVo {
    return CtmsCategoryRespVoFromJSONTyped(json, false);
}

export function CtmsCategoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CtmsCategoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'categoryNameEn': json['categoryNameEn'] == null ? undefined : json['categoryNameEn'],
        'categoryNameCn': json['categoryNameCn'] == null ? undefined : json['categoryNameCn'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function CtmsCategoryRespVoToJSON(json: any): CtmsCategoryRespVo {
    return CtmsCategoryRespVoToJSONTyped(json, false);
}

export function CtmsCategoryRespVoToJSONTyped(value?: CtmsCategoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'categoryName': value['categoryName'],
        'categoryNameEn': value['categoryNameEn'],
        'categoryNameCn': value['categoryNameCn'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

